// $(document).ready(function(){
//   $('.column_slider .get-a-quote-form, .collection-banner-button .get-a-quote-form').on('click', function(){
//     $(".get-a-quote-popup-wrapper").toggleClass('show-form');
//     $('body').css('overflow', 'hidden');
//   });
//   $(".cross-form").click(function(){
//     $(".get-a-quote-popup-wrapper").removeClass('show-form');
//     $('body').css('overflow', 'unset');
//   });  
// });


document.addEventListener('DOMContentLoaded', function () {
  const quoteButtons = document.querySelectorAll('.column_slider .get-a-quote-form, .collection-banner-button.get-a-quote-form');
  const popupWrapper = document.querySelector('.get-a-quote-popup-wrapper');
  const closeButton = document.querySelector('.cross-form');
  quoteButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      popupWrapper.classList.toggle('show-form');
      document.body.style.overflow = 'hidden';
    });
  });
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      popupWrapper.classList.remove('show-form');
      document.body.style.overflow = 'unset';
    });
  }
});
